import React, { useState } from 'react';
import { Layout, Menu, Card, Typography, Breadcrumb } from 'antd';
import {
  SettingOutlined,
  UserOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  BarChartOutlined,
  TagOutlined,
  MailOutlined,
  SecurityScanOutlined,
  CloudOutlined,
  AppstoreOutlined,
  ApartmentOutlined,
  GiftOutlined
} from '@ant-design/icons';
import '../css/AdminPanel.css';

// 导入各个管理模块组件
import UserManagement from '../components/admin/UserManagement';
import SystemSettings from '../components/admin/SystemSettings';
import NotesManagement from '../components/admin/NotesManagement';
import TagsManagement from '../components/admin/TagsManagement';
import SystemLogs from '../components/admin/SystemLogs';
import EmailManagement from '../components/admin/EmailManagement';
import SecurityManagement from '../components/admin/SecurityManagement';
import BackupManagement from '../components/admin/BackupManagement';
import SystemMonitor from '../components/admin/SystemMonitor';
import TopicTreeManagement from '../components/admin/TopicTreeManagement';
import PromoCodeManagement from '../components/admin/PromoCodeManagement';

const { Sider, Content } = Layout;
const { Title } = Typography;

const AdminPanel = () => {
  const [selectedMenuItem, setSelectedMenuItem] = useState('dashboard');
  const [collapsed, setCollapsed] = useState(false);

  // 菜单项配置
  const menuItems = [
    {
      key: 'dashboard',
      icon: <AppstoreOutlined />,
      label: 'Dashboard Overview',
      component: <SystemMonitor />
    },
    {
      key: 'users',
      icon: <UserOutlined />,
      label: 'User Management',
      component: <UserManagement />
    },
    {
      key: 'notes',
      icon: <FileTextOutlined />,
      label: 'Notes Management',
      component: <NotesManagement />
    },
    //{
      //key: 'tags',
      //icon: <TagOutlined />,
      //label: '标签管理',
      //component: <TagsManagement />
    //},
    {
      key: 'topictree',
      icon: <ApartmentOutlined />,
      label: 'TopicTree Management',
      component: <TopicTreeManagement />
    },
    {
      key: 'promocodes',
      icon: <GiftOutlined />,
      label: 'Promo Code Management',
      component: <PromoCodeManagement />
    },
    // 移除数据库管理菜单项
    // {
    //   key: 'database',
    //   icon: <DatabaseOutlined />,
    //   label: '数据库管理',
    //   component: <DatabaseManagement />
    // },
    {
      key: 'logs',
      icon: <BarChartOutlined />,
      label: 'System Logs',
      component: <SystemLogs />
    },
    {
      key: 'email',
      icon: <MailOutlined />,
      label: 'Email Management',
      component: <EmailManagement />
    },
    {
      key: 'security',
      icon: <SecurityScanOutlined />,
      label: 'Security Management',
      component: <SecurityManagement />
    },
    {
      key: 'backup',
      icon: <CloudOutlined />,
      label: 'Backup Management',
      component: <BackupManagement />
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'System Settings',
      component: <SystemSettings />
    }
  ];

  const handleMenuClick = (e) => {
    setSelectedMenuItem(e.key);
  };

  const getCurrentMenuItem = () => {
    return menuItems.find(item => item.key === selectedMenuItem);
  };

  const getCurrentComponent = () => {
    const currentItem = getCurrentMenuItem();
    return currentItem ? currentItem.component : <SystemMonitor />;
  };

  const getCurrentBreadcrumb = () => {
    const currentItem = getCurrentMenuItem();
    return currentItem ? currentItem.label : 'Dashboard Overview';
  };

  return (
    <div className="admin-panel">
      <Layout style={{ minHeight: '100vh' }}>
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          width={250}
          className="admin-sider"
        >
          <div className="admin-logo">
            <Title level={4} style={{ color: '#fff', margin: 0, padding: '16px' }}>
              {collapsed ? 'Admin' : 'System Admin'}
            </Title>
          </div>
          <Menu
            theme="dark"
            selectedKeys={[selectedMenuItem]}
            mode="inline"
            onClick={handleMenuClick}
            items={menuItems.map(item => ({
              key: item.key,
              icon: item.icon,
              label: item.label
            }))}
          />
        </Sider>
        
        <Layout className="admin-layout">
          <Content className="admin-content">
            <div className="admin-breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item>System Admin</Breadcrumb.Item>
                <Breadcrumb.Item>{getCurrentBreadcrumb()}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            
            <Card className="admin-work-area">
              {getCurrentComponent()}
            </Card>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};

export default AdminPanel; 